"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _LegacyOwnersStore = _interopRequireDefault(require("crm_data/owners/LegacyOwnersStore"));

function _default(ownerFormatter) {
  return {
    stores: [_LegacyOwnersStore.default],
    deref: function deref() {
      // TODO this is going to create problems when Owners switches to a paged endpoint
      return _LegacyOwnersStore.default.get().map(function (owner) {
        var ownerName = ownerFormatter.format(owner);
        var ownerNameWithEmail = ownerFormatter.formatWithEmail(owner);
        return {
          value: String(owner.ownerId),
          text: ownerName,
          searchText: ownerNameWithEmail,
          dropdownText: ownerNameWithEmail
        };
      }).toArray();
    }
  };
}

module.exports = exports.default;